import { PropsWithChildren } from 'react'

import styled, { css } from 'styled-components'

export const Container = styled.div`
  padding: 10px 0px 10px 0px;
`

export const SelectionContainer = styled.button<PropsWithChildren<object>>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border: none;
  cursor: pointer;
  background: none;
  width: 100%;
`

export const ListLabel = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.text};
    font-family: ${theme.fonts.text};
    font-weight: ${theme.fonts.textWeight};
    justify-content: center;

    font-size: 16px;
  `}
`
